export default __webpack_public_path__ + "static/media/e-merkator-tv-pt.be21946e.png";